import {
  AreaChart as RechartsAreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend
} from 'recharts';

import { ChartTooltip } from '../chart-tooltip/chart-tooltip.component';
import { ChartLegend } from '../chart-legend/chart-legend.component';
import { style } from './area-chart.module.css';

interface Props {
  data: ({ x: Date; y: Record<string, number> })[];
  showLegend?: boolean;
  formatX: (value: Date) => string;
  formatY: (value: number) => string;
  areas: {
    key: string;
    title: string;
    color: string;
    fillColor?: string;
  }[];
}

export function AreaChart(props: Props) {

  const {
    data,
    areas,
    showLegend = false,
    formatX,
    formatY
  } = props;

  return (
    <ResponsiveContainer initialDimension={{ width: 100, height: 100 }}>
      <RechartsAreaChart data={data.map(item => ({ x: item.x, ...item.y }))}>
        <CartesianGrid 
          vertical={false} 
          stroke={'var(--color-neutral-200)'} 
          strokeWidth={0.5}/>
        <XAxis
          dataKey='x'
          axisLine={false}
          tickLine={false}
          tick={{ className: style.axisTick }}
          tickFormatter={formatX}
          dy={10}/>
        <YAxis
          width='auto'
          axisLine={false}
          tickLine={false}
          tick={{ className: style.axisTick }}
          tickFormatter={formatY}/>
        <Tooltip 
          content={
            <ChartTooltip
              formatLabel={formatX}
              formatValue={formatY}/>
          }/>
        {showLegend && (
          <Legend content={<ChartLegend />}/>
        )}
        {areas.map((area) => (
          <Area
            key={area.key}
            name={area.title}
            type="monotone"
            dataKey={area.key}
            stroke={area.color}
            strokeWidth={2}
            fill={area.fillColor || area.color}
            dot={{ r: 2, fill: area.color, fillOpacity: 1 }}
            activeDot={{ r: 4, strokeWidth: 0, fill: area.color }}/>
        ))}
      </RechartsAreaChart>
    </ResponsiveContainer>
  );
}
